// The values of the Postgres enums of the root that travel in the contracts (ADR-271): plain tuples, without zod, so
// that @nexxt/db builds its enums without evaluating any schema. The root of @nexxt/contracts re-exports them.

/** `platform.actor_type`: user, internal process (cron, Workflow, consumer) or integration (TIL). */
export const actorTypes = ["user", "system", "integration"] as const;
export type ActorType = (typeof actorTypes)[number];

/** The apps of the suite (ADR-102), `party.role_audience`: the audience of a role is the app it opens (ADR-157). */
export const suiteApps = ["backstage", "atelier", "frontrow", "guestlist"] as const;
export type SuiteApp = (typeof suiteApps)[number];

/**
 * The apps of the users of Tomorrow, who sign in with Logto (ADR-024): a role of one of them is for the internal
 * organization only, without the second factor of Nexxt (ADR-294).
 */
export const internalApps = ["backstage", "guestlist"] as const satisfies readonly SuiteApp[];
export type InternalApp = (typeof internalApps)[number];

/**
 * The apps of the external users, who sign in to Nexxt with a password (ADR-147): the links of identity and party go
 * to one of them, and each is a relying party of its own for the passkeys (ADR-206).
 */
export const externalApps = ["atelier", "frontrow"] as const satisfies readonly SuiteApp[];
export type ExternalApp = (typeof externalApps)[number];

/** `party.delegated_access_kind`: a personal token made in Backstage, or a connection an OAuth consent made (ADR-262). */
export const delegatedAccessKinds = ["token", "connection"] as const;
export type DelegatedAccessKind = (typeof delegatedAccessKinds)[number];

/** `party.auth_provider`: Logto for the internal users, Nexxt's own login for the external ones (ADR-024). */
export const authProviders = ["logto", "local"] as const;
export type AuthProvider = (typeof authProviders)[number];

/** `platform.job_status`: how a bulk job or an import batch is doing. */
export const jobStatuses = ["queued", "running", "completed", "partially_failed", "failed", "cancelled"] as const;
export type JobStatus = (typeof jobStatuses)[number];

/** `party.field_access`. */
export const fieldAccessLevels = ["hidden", "read", "write"] as const;
export type FieldAccess = (typeof fieldAccessLevels)[number];

/**
 * What a change that leaves the status where it is touched, as `…Changed.v1` of procurement and catalog says it
 * (ADR-307): lines, the supplier's proposals, prices.
 */
export const changeKinds = ["lines", "proposal", "prices"] as const;
export type ChangeKind = (typeof changeKinds)[number];
